const tagActionTypes = {
    START_GET_TAGS_LIST: 'START_GET_TAGS_LIST',
    GET_TAGS_LIST_SUCCESS: 'GET_TAGS_LIST_SUCCESS',
    GET_TAGS_LIST_FAILURE: 'GET_TAGS_LIST_FAILURE',

    START_ADD_TAG: 'START_ADD_TAG',
    ADD_TAG_SUCCESS: 'ADD_TAG_SUCCESS',
    ADD_TAG_FAILURE: 'ADD_TAG_FAILURE',

    START_EDIT_TAG: 'START_EDIT_TAG',
    EDIT_TAG_SUCCESS: 'EDIT_TAG_SUCCESS',
    EDIT_TAG_FAILURE: 'EDIT_TAG_FAILURE',

    START_DELETE_TAG: 'START_DELETE_TAG',
    DELETE_TAG_SUCCESS: 'DELETE_TAG_SUCCESS',
    DELETE_TAG_FAILURE: 'DELETE_TAG_FAILURE',
}

export default tagActionTypes;